import {
  colorName,
  findVariant,
  isColorAvailable,
  optionAvailability,
  type VariantsShape,
} from './variants';

export type Selection = { colorId: string | null; size: string | null };

/** Result of a colour click: the new selection and an optional tip (texts from design 03B). */
export function selectColor(
  product: VariantsShape,
  current: Selection,
  colorId: string,
): { selection: Selection; tip: string } {
  const name = colorName(product, colorId) ?? '';
  if (!isColorAvailable(product, colorId))
    return { selection: current, tip: `Цвета «${name}» сейчас нет в наличии` };
  if (
    current.size &&
    product.sizes.length > 1 &&
    optionAvailability(product, colorId, current.size) === 'out_of_stock'
  ) {
    return {
      selection: { colorId, size: null },
      tip: `Размер ${current.size} недоступен в цвете «${name}» — выберите размер заново`,
    };
  }
  return { selection: { ...current, colorId }, tip: '' };
}

export function selectSize(
  product: VariantsShape,
  current: Selection,
  size: string,
): { selection: Selection; tip: string } {
  if (optionAvailability(product, current.colorId, size) === 'out_of_stock') {
    const name = colorName(product, current.colorId);
    return {
      selection: current,
      tip: name
        ? `Размер ${size} сейчас недоступен в цвете «${name}». Выберите другой размер или цвет`
        : `Размер ${size} сейчас недоступен`,
    };
  }
  return { selection: { ...current, size }, tip: '' };
}

/** Why the current selection cannot be bought, or null when it can. */
export function purchaseBlocker(product: VariantsShape, selection: Selection): string | null {
  if (product.sizes.length > 1 && !selection.size)
    return 'Выберите размер, чтобы добавить товар в корзину';
  const variant = findVariant(product, selection);
  if (!variant || variant.availability === 'out_of_stock') {
    return selection.size && product.sizes.length > 1
      ? `Размер ${selection.size} нет в наличии — выберите другой`
      : 'Этого варианта сейчас нет в наличии';
  }
  if (!variant.price) return 'Цена уточняется — товар пока нельзя купить';
  return null;
}
